import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['3 módulos completos en PDF de alta calidad', 'Formación basada en normativa vigente Argentina (AEA)', 'Casos reales aplicados a viviendas', 'Clases en vivo con docente profesional', 'Acceso a clases grabadas sin límite', 'Comunidad activa de alumnos', 'Soporte directo del profesor', 'Ayuda y feedback entre alumnos', 'Actualizaciones de contenido incluidas', 'Formación práctica con criterio profesional'];
export function Includes() {
  return <section id="incluye" className="py-24 bg-ed-black relative border-t border-white/5 overflow-hidden" data-id="element-256">
      <div className="absolute inset-0 bg-radial-green opacity-30 pointer-events-none" data-id="element-257"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-258">
        <div className="text-center mb-14 max-w-2xl mx-auto" data-id="element-259">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-260">
            Todo lo que recibís
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-4" data-id="element-261">
            ¿Qué incluye la formación?
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-262">
            Una formación completa, sin letra chica. Todo lo que necesitás para
            convertirte en electricista domiciliario profesional.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="bg-ed-dark border border-zinc-800 rounded-3xl p-8 sm:p-12 shadow-2xl" data-id="element-263">
          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5" data-id="element-264">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-265">
                <div className="w-6 h-6 rounded-md bg-ed-green/15 border border-ed-green/40 flex items-center justify-center shrink-0 mt-0.5" data-id="element-266">
                  <Check className="w-3.5 h-3.5 text-ed-green" strokeWidth={3} data-id="element-267" />
                </div>
                <span className="text-zinc-200 font-medium leading-snug pt-0.5" data-id="element-268">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}